export const indigoMui = {
  /**
   * Preview: ![indigo 50](https://mui.com/static/colors-preview/indigo-50-24x24.png)
   */
  _50: "#e8eaf6",
  /**
   * Preview: ![indigo 100](https://mui.com/static/colors-preview/indigo-100-24x24.png)
   */
  _100: "#c5cae9",
  /**
   * Preview: ![indigo 200](https://mui.com/static/colors-preview/indigo-200-24x24.png)
   */
  _200: "#9fa8da",
  /**
   * Preview: ![indigo 300](https://mui.com/static/colors-preview/indigo-300-24x24.png)
   */
  _300: "#7986cb",
  /**
   * Preview: ![indigo 400](https://mui.com/static/colors-preview/indigo-400-24x24.png)
   */
  _400: "#5c6bc0",
  /**
   * Preview: ![indigo 500](https://mui.com/static/colors-preview/indigo-500-24x24.png)
   */
  _500: "#3f51b5",
  /**
   * Preview: ![indigo 600](https://mui.com/static/colors-preview/indigo-600-24x24.png)
   */
  _600: "#3949ab",
  /**
   * Preview: ![indigo 700](https://mui.com/static/colors-preview/indigo-700-24x24.png)
   */
  _700: "#303f9f",
  /**
   * Preview: ![indigo 800](https://mui.com/static/colors-preview/indigo-800-24x24.png)
   */
  _800: "#283593",
  /**
   * Preview: ![indigo 900](https://mui.com/static/colors-preview/indigo-900-24x24.png)
   */
  _900: "#1a237e",
  /**
   * Preview: ![indigo A100](https://mui.com/static/colors-preview/indigo-A100-24x24.png)
   */
  A100: "#8c9eff",
  /**
   * Preview: ![indigo A200](https://mui.com/static/colors-preview/indigo-A200-24x24.png)
   */
  A200: "#536dfe",
  /**
   * Preview: ![indigo A400](https://mui.com/static/colors-preview/indigo-A400-24x24.png)
   */
  A400: "#3d5afe",
  /**
   * Preview: ![indigo A700](https://mui.com/static/colors-preview/indigo-A700-24x24.png)
   */
  A700: "#304ffe",
};
